module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/128-spain-5f30750a77f9be43ca71b0173638615a.svg";